module.exports = __webpack_public_path__ + "img/tl-2.8cca1dd8.jpg";